import React from "react";
import DashboardGridSkelton from "features/dashboard/components/Common/DashboardGridSkelton";
import DataGrid from "./DataGrid";
import { NoContentPage } from "features/dashboard/components/Common/NoContentPage";
import nothingToshow from "features/dashboard/assets/svg/nothing-to-show.svg";
import { IGridListProps } from "features/dashboard/types";



/**
 * DashboardGrid component
 * @returns {JSX.Element}
 */
const DashboardGrid = (girdData:IGridListProps) => {
  if(girdData?.isLoading) {
    return <DashboardGridSkelton />
  }
  return (
    <div>
      { girdData &&
        girdData?.["rowData"] &&
        girdData?.["rowData"].length > 0 ? (
        <div>
          <DataGrid {...girdData} />
        </div>
      ) : (
        <NoContentPage
          // title="Nothing to show"
          title="No offers available"
          src={nothingToshow}
          msg=""
        />
      )}
    </div>
  );
};

export default DashboardGrid;
